var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Property } from './Property';
import { multipleCallback } from './util/multipleCallback';
export function combine(properties, map) {
    return new /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.get = function () {
            var values = properties.map(function (prop) { return prop.get(); });
            return map.apply(void 0, values);
        };
        class_1.prototype.subscribe = function (cb) {
            return multipleCallback(properties.map(function (prop) { return prop.subscribe(cb); }));
        };
        return class_1;
    }(Property));
}
//# sourceMappingURL=combine.js.map